/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { FaBell } from '@react-icons/all-files/fa/FaBell'
import { FaSitemap } from '@react-icons/all-files/fa/FaSitemap'
import { FaSearch } from '@react-icons/all-files/fa/FaSearch'
import { AiOutlineCloseCircle } from '@react-icons/all-files/ai/AiOutlineCloseCircle'
import { FaCircle } from '@react-icons/all-files/fa/FaCircle'
import { IoMdLogOut } from '@react-icons/all-files/io/IoMdLogOut'
import { IoMdMenu } from '@react-icons/all-files/io/IoMdMenu'
import { IoMdClose } from '@react-icons/all-files/io/IoMdClose'
import { MdFavorite } from '@react-icons/all-files/md/MdFavorite'
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import dayjs from 'dayjs'
import { toast } from 'react-toastify'

import useComponentVisible from '../hooks/useComponentVisible'
import SiteMap from './SiteMap'
import {
	setNotifications,
	clearAll,
	removeNotification
} from '../slices/notificationSlice'
import useLogout from '../hooks/useLogout'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import MyList from './MyList'
import MobileMenu from './MobileMenu'

const HeaderDesktop = () => {
	const [keyword, setKeyword] = useState('')
	const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false)

	const {
		ref: refSiteMap,
		isComponentVisible: isSiteMapVisible,
		setIsComponentVisible: setIsSiteMapVisible
	} = useComponentVisible(false)

	const {
		ref: refSearchBox,
		isComponentVisible: isSearchBoxVisible,
		setIsComponentVisible: setIsSearchBoxVisible
	} = useComponentVisible(false)

	const {
		ref: refMyList,
		isComponentVisible: isMyListVisible,
		setIsComponentVisible: setIsMyListVisible
	} = useComponentVisible(false)

	const {
		ref: refMobileMenu,
		isComponentVisible: isMobileMenuVisible,
		setIsComponentVisible: setIsMobileMenuVisible
	} = useComponentVisible(false)

	const { notiItems } = useSelector(state => state.notifications)
	const { userInfo } = useSelector(state => state.auth)
	const { menu, hiddenProfile } = useSelector(state => state.navigation)
	const dispatch = useDispatch()
	const axiosPrivate = useAxiosPrivate()
	const { pathname, search } = useLocation()

	const navigate = useNavigate()

	const logout = useLogout()

	useEffect(() => {
		const handleEvent = async event => {
			// const messageId =
			// 	event.data.messageType === 'push-received'
			// 		? event.data.fcmMessageId
			// 		: event.data.messageId

			const { data } = await axiosPrivate.get('/POP_Homepage/GetNotiList')

			dispatch(setNotifications(data.noti_List))

			// Swal.fire({
			// 	customClass: 'swal-noti',
			// 	position: 'top-end',
			// 	title: 'Notifications',
			// 	text: 'You received new notification',
			// 	icon: 'info',
			// 	confirmButtonText: 'Ok'
			// })
			toast('You received new notification', {
				position: 'top-right',
				autoClose: 3000
			})
		}

		navigator.serviceWorker.addEventListener('message', handleEvent)

		return () => {
			navigator.serviceWorker.removeEventListener('message', handleEvent)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		setIsSiteMapVisible(false)
		setIsMyListVisible(false)
		setIsMobileMenuVisible(false)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname, search])

	const handleLogout = () => {
		Swal.fire({
			title: 'Are you sure?',
			text: 'you want to log out',
			icon: 'warning',
			showCancelButton: true,
			cancelButtonColor: '#bbb',
			confirmButtonText: 'Yes',
			cancelButtonText: 'No'
		}).then(result => {
			if (result.isConfirmed) {
				logout()
			}
		})
	}

	const handleSearch = e => {
		e.preventDefault()
		setIsSearchBoxVisible(false)
		navigate(`/search-results?q=${keyword}`)
	}

	const renderMenu = item => {
		if (item.accessCode?.startsWith('N')) {
			return (
				<li key={item.menuID} className={item.isNeedLineBreak ? 'g-line' : ''}>
					<span className="cursor-not-allowed text-slate-400">{item.menuName}</span>
				</li>
			)
		}

		return (
			<li key={item.menuID} className={item.isNeedLineBreak ? 'g-line' : ''}>
				{item.isBiPage ? (
					<a
						className={!item.biLink ? 'cursor-default !text-gray-700' : ''}
						href={item.biLink}
						target="_blank"
						rel="noreferrer"
					>
						{item.menuName}
					</a>
				) : item.link.includes('?type=') ? (
					<a href={item.link}>{item.menuName}</a>
				) : (
					<Link to={item.link}>{item.menuName}</Link>
				)}
			</li>
		)
	}

	const removeNotificationItem = async (item, isAll = false) => {
		try {
			await axiosPrivate.post(
				`/POP_Homepage/ReadNoti?runId=${item?.runId}&isAll=${isAll}`
			)

			if (isAll) {
				dispatch(clearAll())
			} else {
				dispatch(removeNotification(item.runId))
			}

			if (item.notiLink.startsWith('http')) {
				window.open(item.notiLink)
			} else {
				navigate(item.notiLink)
			}
		} catch (err) {
			//
		} finally {
			setIsComponentVisible(false)
		}
	}

	return (
		<header className="header-desktop relative">
			<div className="header-tools hidden md:flex">
				<div className="flex">
					<div className="sk sk1">
						<a
							className="hover:text-white"
							onClick={() => {
								if (notiItems.length > 0) {
									setIsComponentVisible(true)
								}
							}}
						>
							<span>
								<FaBell />
								{notiItems.length > 0 && (
									<span className="badge">{notiItems.length}</span>
								)}
							</span>
						</a>

						<div
							ref={ref}
							className={`${
								isComponentVisible ? 'visible' : 'invisible'
							} box-notifications`}
						>
							{notiItems.length > 0 && (
								<div className="flex justify-end">
									<a
										className="text-ci2 hover:text-ci1"
										onClick={() => {
											removeNotificationItem({ runId: null }, true)
										}}
									>
										Clear All
									</a>
								</div>
							)}

							<div className="border-b-2 border-b-borderLight mt-1 pb-1">
								<h2 className="text-ci4 text-lg">Notifications</h2>
							</div>

							{notiItems.length > 0 ? (
								<ul className="mt-3 max-h-80 overflow-auto">
									{notiItems.map((item, idx) => (
										<li key={item.notilId} className="notification-item">
											<FaCircle className="disc" />
											<a onClick={() => removeNotificationItem(item)}>
												<h3 className="notification-title">
													{item.notiTitle}
												</h3>
												<span className="notification-sub">
													<span className="flex-1 line-clamp-1">
														{item.notiBody}
													</span>
													<span>
														{dayjs(item.sendDate).format('DD/MM/YYYY')} -{' '}
														{dayjs(item.sendDate).format('HH:mm')}
													</span>
												</span>
											</a>
										</li>
									))}
								</ul>
							) : null}
						</div>
					</div>

					<div className="sk sk2">
						<a
							className="hover:text-white"
							onClick={() => setIsMyListVisible(true)}
						>
							<span>
								<MdFavorite />
							</span>
						</a>
					</div>

					<div className="sk sk3">
						<a onClick={() => setIsSiteMapVisible(true)}>
							<span>
								<FaSitemap />
							</span>
						</a>
					</div>

					<div className="sk sk4">
						<a
							onClick={() => {
								setIsSiteMapVisible(false)
								setIsSearchBoxVisible(true)
							}}
						>
							<span>
								<FaSearch />
							</span>
						</a>

						{isSearchBoxVisible && (
							<form
								ref={refSearchBox}
								className="search-box"
								name="search-form"
								onSubmit={handleSearch}
							>
								<span>Search: </span>
								<input
									className="mx-2 h-8"
									type="text"
									placeholder="Enter your keyword..."
									onChange={e => setKeyword(e.target.value)}
								/>
								<a onClick={() => setIsSearchBoxVisible(false)}>
									<AiOutlineCloseCircle />
								</a>
								<button className="hidden" type="submit" form="search-form">
									submit
								</button>
							</form>
						)}
					</div>

					<div className="sk sk5">
						<a
							className="-left-1 relative z-10"
							title="Logout"
							onClick={handleLogout}
						>
							<span>
								<IoMdLogOut size={18} />
							</span>
						</a>
					</div>
				</div>
			</div>

			<div className="flex items-center justify-between relative lg:hidden">
				{!hiddenProfile ? (
					<Link to="/home">
						<img
							alt=""
							src={`${process.env.PUBLIC_URL}/images/logos/logo-one-platform.png`}
							className="h-12 m-3 md:ml-5"
						/>
					</Link>
				) : (
					<img
						alt=""
						src={`${process.env.PUBLIC_URL}/images/logos/logo-one-platform.png`}
						className="h-12 m-3 md:ml-5"
					/>
				)}

				{!hiddenProfile && (
					<div className="flex items-center mr-3">
						<Link className="flex items-center" to="/profile">
							<img
								className="border border-gray-400 rounded-full h-12 object-cover w-12"
								alt="User"
								src={
									userInfo?.picture
										? `${process.env.REACT_APP_BASE_ASSETS}${userInfo?.picture}`
										: `${process.env.PUBLIC_URL}/images/avatar-user.png`
								}
							/>
						</Link>

						<a className="ml-2" onClick={() => setIsMobileMenuVisible(true)}>
							{isMobileMenuVisible ? (
								<IoMdClose size={35} />
							) : (
								<IoMdMenu size={35} />
							)}
						</a>
					</div>
				)}

				{isMobileMenuVisible && <MobileMenu ref={refMobileMenu} />}
			</div>

			<div className="hidden items-end justify-between ml-[6.25%] lg:flex">
				<div className="max-w-[150px] py-4 w-[11%]">
					<Link to="/">
						<img
							alt=""
							src={`${process.env.PUBLIC_URL}/images/logos/logo-one-platform.png`}
						/>
					</Link>
				</div>

				<ul className="nav">
					<li>
						<NavLink to="/home">Home</NavLink>
					</li>
					<li>
						<NavLink to="/crude">Crude</NavLink>
						<div className="submenu">
							<img
								alt=""
								src={`${process.env.PUBLIC_URL}/images/work-stream/ws1.jpg`}
							/>

							<div className="group-submenu">
								<h2 className="text-ci5 text-lg uppercase">Crude</h2>
								<ul>{menu['Crude'].map(renderMenu)}</ul>
							</div>
						</div>
					</li>
					<li>
						<NavLink to="/products">Products</NavLink>
						<div className="submenu">
							<img
								alt=""
								src={`${process.env.PUBLIC_URL}/images/work-stream/ws2.jpg`}
								className=""
							/>

							<div className="group-submenu">
								<h2 className="text-ci5 text-lg uppercase">Products</h2>

								<ul>{menu['Products'].map(renderMenu)}</ul>
							</div>
						</div>
					</li>
					<li>
						<NavLink to="/petrochemical">Petrochemical</NavLink>
						<div className="submenu">
							<img
								alt=""
								src={`${process.env.PUBLIC_URL}/images/work-stream/ws3.jpg`}
								className=""
							/>

							<div className="group-submenu">
								<h2 className="text-ci5 text-lg uppercase">Petrochemical</h2>
								<ul>{menu['Petrochemical'].map(renderMenu)}</ul>
							</div>
						</div>
					</li>
					<li>
						<NavLink to="/chartering">Chartering</NavLink>
						<div className="submenu">
							<img
								alt=""
								src={`${process.env.PUBLIC_URL}/images/work-stream/ws4.jpg`}
								className=""
							/>

							<div className="group-submenu">
								<h2 className="text-ci5 text-lg uppercase">Chartering</h2>
								<ul>{menu['Chartering'].map(renderMenu)}</ul>
							</div>
						</div>
					</li>
					<li>
						<NavLink to="/derivatives">Derivatives</NavLink>
						<div className="submenu">
							<img
								alt=""
								src={`${process.env.PUBLIC_URL}/images/work-stream/ws5.jpg`}
							/>

							<div className="group-submenu">
								<h2 className="text-ci5 text-lg uppercase">Derivatives</h2>
								<ul>{menu['Derivatives'].map(renderMenu)}</ul>
							</div>
						</div>
					</li>
					<li>
						<NavLink to="/market-analysis">Market Analysis</NavLink>
						<div className="submenu">
							<img
								alt=""
								src={`${process.env.PUBLIC_URL}/images/work-stream/ws6.jpg`}
							/>

							<div className="group-submenu">
								<h2 className="text-ci5 text-lg uppercase">Market Analysis</h2>
								<ul>{menu['MarketAnalysis'].map(renderMenu)}</ul>
							</div>
						</div>
					</li>
				</ul>

				<div className="header-user">
					<Link className="flex items-center" to="/profile">
						<img
							className="border border-gray-400 rounded-full h-14 object-cover w-14"
							alt="User"
							src={
								userInfo?.picture
									? `${process.env.REACT_APP_BASE_ASSETS}${userInfo?.picture}`
									: `${process.env.PUBLIC_URL}/images/avatar-user.png`
							}
						/>
						<div className="flex-1 ml-3 w-full">
							<div className="text-md line-clamp-1 ">{userInfo?.employeeName}</div>
							<div className="text-sm line-clamp-1 leading-3">
								{userInfo?.comCode}
							</div>
						</div>
					</Link>
				</div>
			</div>

			{isSiteMapVisible && (
				<SiteMap ref={refSiteMap} handleClose={() => setIsSiteMapVisible(false)} />
			)}

			{isMyListVisible && (
				<MyList
					ref={refMyList}
					isShowMyList={isMyListVisible}
					setIsShowMyList={setIsMyListVisible}
				/>
			)}
		</header>
	)
}

export default HeaderDesktop
